import React from "react";

export default function PlayingIcon(props) {
  return <span className="glyphicon glyphicon-play-circle played-count-icon" style={props.style}></span>;
}

